import {IHttpService} from "angular";

export class UserInterfaceConfigurationService {

    public static readonly id = "userInterfaceConfigurationService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
    }

    public async load<T>(key: string): Promise<T | null> {
        const url = `/tradefloor/api/ui-configuration/${key}`;
        const response = await this.$http.get<string | null>(url, {ignoreLoadingBar: true});
        const data = response.data;
        if ((data == null) || (data === "")) {
            return null;
        } else {
            return JSON.parse(data);
        }
    }

    public async save(key: string, value: any): Promise<void> {
        const url = `/tradefloor/api/ui-configuration/${key}`;
        const payload = JSON.stringify(value);
        await this.$http.put(url, payload, {ignoreLoadingBar: true});
    }

    public async delete(key: string): Promise<void> {
        const url = `/tradefloor/api/ui-configuration/${key}`;
        await this.$http.delete(url, {ignoreLoadingBar: true});
    }
}
